// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3cVv6","name":"Table_name__2wJJ_","amount":"Table_amount__1gAQy","removeItem":"Table_removeItem__1MDYZ"};